// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_MigrarFranquiaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /migration/franquias/migrar
 * (controllers/migration/franquias.php::migrar).
 *
 * O resultado da carga de UMA unidade, exatamente como
 * `MigrationService::migrarFranquia()` o devolve.
 *
 * ---------------------------------------------------------------------------
 * POR QUE `status` E DADO, E NAO UM ERRO DE TRANSPORTE
 * ---------------------------------------------------------------------------
 * `bloqueada` e `falhou` sao DESFECHOS previstos da migracao, nao falhas da
 * requisicao: a etapa foi processada, o run foi aberto e fechado, e o que
 * aconteceu ficou registrado em `migration_runs` / `migration_errors`. A tela
 * precisa do `run_id` e dos `blockers` justamente nesses casos — devolve-los
 * dentro de um `sendError()` (que zera `dados` no envelope canonico) apagaria
 * a unica informacao acionavel. Uma requisicao que nao chega a ser processada
 * — sem permissao, gate desligado, `zoho_id` invalido — essa sim vira erro.
 *
 * Valores de `status` (constantes de MigrationService):
 *   - 'migrada'   carregada agora nesta execucao.
 *   - 'skipped'   ja estava no ledger; NADA foi escrito (prova da idempotencia).
 *   - 'bloqueada' preflight barrou por blocker de severidade 'error'.
 *   - 'falhou'    a carga comecou e falhou; ver `migration_errors` do run.
 */
import type { Migration_BlockerRow } from './Migration_BlockerRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Migration_MigrarFranquiaResponseDados {
zoho_id: string
status: string
run_id: number
blockers: Migration_BlockerRow[]
nome?: string
franquia_id?: number
erro?: string
}

export type Migration_MigrarFranquiaResponse = ApiResponse<Migration_MigrarFranquiaResponseDados>;

registerResponseContract('Migration_MigrarFranquiaResponse', {
  zoho_id:     { type: 'string',  required: true },
  status:      { type: 'string',  required: true },
  run_id:      { type: 'number',  required: true },
  blockers: {
    type: 'array',
    required: true,
    items: {
      code:     { type: 'string',  required: false },
      message:  { type: 'string',  required: false },
      severity: { type: 'string',  required: false },
      entity:   { type: 'string',  required: false },
      zoho_id:  { type: 'string',  required: false },
      label:    { type: 'string',  required: false },
    },
  },
  nome:        { type: 'string',  required: false },
  franquia_id: { type: 'number',  required: false },
  erro:        { type: 'string',  required: false },
})
